module.exports = __webpack_public_path__ + "front/img/33_3.78608880.png";